export const modalSetting = {
  component: null,
  width: "400",
  height: "300",
  show: false,
  title: null,
};

export const sliderSetting = {
  component: null,
  header: null,
  width: "400",
  height: "300",
  show: false,
  doNotHide: false,
};
